import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchSalesChannel,
  getIsCurrentSalesChannel,
  getCurrentSalesChannel,
  onClearStoredSalesChannel,
  getSalesChannelIsLoading,
} from './slice';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';
import { ChannelType } from 'src/types/common/SalesChannel';
import { dispatch } from 'src/store';
import emit from 'src/tools/event';
import { UPDATE_SC_SETTING } from 'src/tools/constant';
const useClearSalesChannel = () => {
  // console.log('useClearSalesChannel');
  dispatch(onClearStoredSalesChannel());
};

const useFetchSalesChannel = (da?) => {
  const { uuid: oU, uuidKey, forceUpdate } = da || {};
  const p: any = useParams();
  const _uuid = p[uuidKey || 'uuid'];
  const uuid = oU || _uuid;
  const d = useDispatch();
  const isCurrentSalesChannel = useSelector(getIsCurrentSalesChannel(uuid));
  const currentSalesChannel = useSelector(getCurrentSalesChannel());
  const loading = useSelector(getSalesChannelIsLoading());
  const handleOnFetchSalesChannel = () => {
    d(fetchSalesChannel({ salesChannelUuid: uuid }));
  };
  const salesChannelUuid = get(currentSalesChannel, 'uuid');
  React.useEffect(() => {
    if (forceUpdate) {
      handleOnFetchSalesChannel();
    }
    // return () => {
    //   useClearSalesChannel();
    // };
    emit.on(UPDATE_SC_SETTING, handleOnFetchSalesChannel);
    return () => {
      emit.removeListener(UPDATE_SC_SETTING, handleOnFetchSalesChannel);
    };
  }, []);
  React.useEffect(() => {
    if (salesChannelUuid) {
      if (isCurrentSalesChannel) {
      } else {
        handleOnFetchSalesChannel();
      }
    }
  }, [isCurrentSalesChannel]);
  //console.log('isCurrentSalesChannel', isCurrentSalesChannel);

  return {
    salesChannel: currentSalesChannel || {},
    loading,
    isCurrentSalesChannel,
  };
};

const useSalesChannel = () => {
  const s = useSelector(getCurrentSalesChannel());
  return s;
};

const useSalesChannelType = () => {
  const salesChannel = useSelector(getCurrentSalesChannel());
  const channelType = get(salesChannel, 'channelType');
  return channelType;
};

const useSalesChannelIsMiniProgram = () => {
  const salesChannel = useSelector(getCurrentSalesChannel());
  const channelType = get(salesChannel, 'channelType');
  return channelType === ChannelType.MiniProgram;
};

export {
  useFetchSalesChannel,
  useSalesChannel,
  useSalesChannelType,
  useClearSalesChannel,
  useSalesChannelIsMiniProgram,
};
